module.exports = __webpack_public_path__ + "img/mercado-pago.56e90e94.png";